import { render, staticRenderFns } from "./suggestions.vue?vue&type=template&id=3928ec6a&vue3"
import script from "./suggestions.vue?vue&type=script&lang=js&vue3"
export * from "./suggestions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports